// extracted by mini-css-extract-plugin
export default {"feedbackForm":"FeedbackForm_feedbackForm__EhPph","feedbackForm__name":"FeedbackForm_feedbackForm__name__8OyYs","feedbackForm__item":"FeedbackForm_feedbackForm__item__aJ-B9"};